import { useScaleEvents } from '@components/ArtBoard/Canvas/hooks/events'
import { Button } from '@octopus-do/octopus-storybook'
import { Minus, Plus } from '@octopus-do/octopus-storybook/icons'
import { migrationCanvasSelectors } from '@store/migrationSelectors/canvasSelectors'
import type React from 'react'
import { useSelector } from 'react-redux'

import css from './Zoom.module.scss'

const Zoom: React.FC = () => {
  const { onZoomIn, onZoomOut, onResetZoom } = useScaleEvents()

  const scale = useSelector(migrationCanvasSelectors.getScale)

  const zoom = Math.round(scale * 100)

  return (
    <div className={css.buttonsWrap}>
      <Button
        priority="ghost"
        size="medium"
        left={Minus}
        aria-label="Zoom out"
        data-testid="zoom-minus"
        onClick={() => onZoomOut()}
      />

      <Button
        className={css.centerBtn}
        priority="ghost"
        size="medium"
        label={`${zoom}%`}
        data-testid="zoom"
        onClick={onResetZoom}
      />

      <Button
        priority="ghost"
        size="medium"
        left={Plus}
        aria-label="Zoom in"
        data-testid="zoom-plus"
        onClick={() => onZoomIn()}
      />
    </div>
  )
}

export default Zoom
